/* eslint-disable no-nested-ternary */
/* eslint-disable react/require-default-props */
import { Avatar, Badge, Button, useMediaQuery, useTheme } from "@mui/material";
import moment from "moment";
import { useRouter } from "next/router";
import React, { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useDispatch, useSelector, useStore } from "react-redux";
import CopyToClipboard from "react-copy-to-clipboard";
import { isEmpty } from "../../../utils/helpers/helpers";
import AddCircleOutlinedIcon from "../../../../public/assets/icons/AddCircleOutlinedIcon";
import IconDiamond from "../../../../public/assets/icons/IconDiamond";
import Star from "../../../../public/assets/icons/Star";
import { commonActions } from "../redux/actions";
import IconCameraAccount, { IconCameraSmall } from "../../account/assets/icons/IconCameraAccount";

import IconPremium, { IconPremiumSmall } from "../../account/assets/icons/IconPremium";
import { TInfoAccount } from "../../account/utils/types";
import { abbreviateNumberFormatter } from "../utils/constant";
import { listRelationshipMappingAccount } from "../../account/utils/constant";
import { MenuActionFriend } from "../../friends/components/MenuActionFriend";
import {
  handleAcceptFriend,
  handleDeclineFriendRequest,
  handleDeleteInvitation,
  handleDeleteFollow,
  handleRemoveFriend,
  handleInviteFriend,
  handleFollowFriend,
  handleGetAccountDetail
} from "../../common/utils/commonAPI";
import {
  getRelationshipButtonIdFollow,
  getRelationshipButtonIdFriend,
  LIST_ACTION_CHECK_UPDATE_UI
} from "../../friends/utils/constant";
import { TFriendState } from "../../friends/utils/types";
import { friendActions } from "../../friends/redux/actions";
import IconCopy from "../../../../public/assets/icons/IconCopy";
import { toastSuccess } from "./toastify";
import { TTheme } from "../../../utils/configs/setupTheme";
import { eventTracking } from "../../../firebase/firebaseConfig";
import { TCommonState } from "../utils/type";

type TProps = {
  infoAccount: TInfoAccount;
  isFriendPreview?: boolean;
  handleOpenModalGiftDiamond?: () => void;
  // handleCloseModalGiftDiamond?: () => void;
};

const AccountPreview: React.FC<TProps> = ({ infoAccount, isFriendPreview, handleOpenModalGiftDiamond = () => {} }) => {
  const intl = useIntl();
  const router = useRouter();
  const theme: TTheme = useTheme();
  const store = useStore();
  const dispatch = useDispatch();
  const matches768 = useMediaQuery("(min-width:768px)");
  const buttonFriendId = getRelationshipButtonIdFriend(infoAccount?.relationship);
  const buttonFollowId = getRelationshipButtonIdFollow(infoAccount?.relationship);
  const notify = useSelector((state: { friend: TFriendState }) => state.friend.notify);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };
  const dataUser = useSelector((state: { commonNew: TCommonState }) => state.commonNew.userInfos);
  const checkViewMySelf = infoAccount?.pub_id === dataUser?.member?.pub_id;
  const checkPremiumMember = !isEmpty(infoAccount?.vip_to) && (infoAccount?.vip_to as number) >= moment().unix();
  useEffect(() => {
    if (LIST_ACTION_CHECK_UPDATE_UI.includes(notify?.type)) {
      handleGetAccountDetail(store, router?.query?.memberHid || router?.query?.f);
      dispatch(friendActions.handleClearNotify());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notify?.type]);
  return (
    <div className={`${checkViewMySelf && "pb-8"}`}>
      <div>
        <div className="relative">
          <div>
            <img
              src="/assets/images/AccountBacgroundDefault.webp"
              alt="Account Background Default"
              className="w-full aspect-[3/1] rounded-t-md h-[212px] object-cover"
            />
          </div>
          <div className="absolute tablet:bottom-[-107px] md:bottom-[-90px] left-4 sm:bottom-[-11px]">
            <div className="border-[3px] rounded-full border-white">
              <Badge
                overlap="circular"
                anchorOrigin={{ vertical: "top", horizontal: "left" }}
                badgeContent={
                  !isFriendPreview &&
                  (checkPremiumMember ? <div>{matches768 ? <IconPremium /> : <IconPremiumSmall />}</div> : "")
                }
              >
                <Avatar
                  alt={infoAccount?.name}
                  src={infoAccount?.avatar}
                  className="md:w-[168px] md:h-[168px] sm:w-[72px] sm:h-[72px]"
                />
                {!isFriendPreview && (
                  <button
                    type="button"
                    className="absolute md:right-2 md:bottom-2 sm:right-0 sm:bottom-0 md:w-[32px] md:h-[32px] sm:w-[20px] sm:h-[20px] "
                    onClick={() => dispatch(commonActions.handleOpenModalChangeAvatar(true))}
                  >
                    <span className="sm:hidden md:inline">
                      <IconCameraAccount />
                    </span>
                    <span className="sm:inline md:hidden">
                      <IconCameraSmall />
                    </span>
                  </button>
                )}
              </Badge>
            </div>
          </div>
        </div>
        <div className="flex flex-col static sm:mt-[21px] 2xl:mt-[16px] gap-y-[10px]">
          <div className="flex justify-end flex-row w-full">
            <div className="md:w-[calc(100%-168px-16px)] sm:w-full px-4 flex justify-between flex-row items-baseline flex-wrap">
              <div className="flex-col flex gap-y-[7.5px] w-[calc(100%-120px)]">
                <span className="text-[18px] font-semibold break-all">{infoAccount?.display_name}</span>
                <span className="text-[12px] text-gray400 font-normal flex">
                  {isFriendPreview ? (
                    <FormattedMessage
                      id="friend.friendCard.gradeLevel"
                      values={{
                        grade: infoAccount?.grade,
                        level: infoAccount?.level
                      }}
                    />
                  ) : (
                    <>
                      <FormattedMessage
                        id="Profile.yourReferencesCodeIs"
                        values={{
                          code: infoAccount?.pub_id
                        }}
                      />
                      <CopyToClipboard
                        text={infoAccount?.pub_id as string}
                        onCopy={() => toastSuccess(intl.formatMessage({ id: "coppie-success" }))}
                      >
                        <button onClick={() => {}} type="button" className="ml-2">
                          <IconCopy />
                        </button>
                      </CopyToClipboard>
                    </>
                  )}
                </span>
              </div>
              <div>
                {!isFriendPreview ? (
                  <Button
                    sx={{
                      border: checkPremiumMember ? "1px solid transparent" : "none"
                    }}
                    className={`${
                      checkPremiumMember ? "text-green border-gradient-green" : " bg-accept text-white "
                    } py-2 rounded-[100px] text-[13px] font-semibold min-w-[105px] h-[32px] flex items-center justify-center`}
                    onClick={() => router.push("/kim-cuong/nang-cap-vip")}
                  >
                    <FormattedMessage id={checkPremiumMember ? "extend-premium" : "Upgrade"} />
                  </Button>
                ) : !checkViewMySelf ? (
                  <Button
                    sx={{ textTransform: "none" }}
                    className="w-[105px] h-[32px] text-[13px] font-[500] rounded-[100px] bg-green-gradient text-white gap-2 flex justify-center items-center"
                    onClick={() => eventTracking("view_give_diamond", {}, () => handleOpenModalGiftDiamond())}
                  >
                    <span>
                      <FormattedMessage id="ask.createPost.bonus" />
                    </span>
                    <IconDiamond fill="white" />
                  </Button>
                ) : null}
              </div>
            </div>
          </div>
          {isFriendPreview ? (
            <div className="mb-4 md:pt-4 tablet:pt-0">
              {checkViewMySelf ? null : (
                <div className="flex gap-[10px] sm:justify-center md:justify-end px-4">
                  <Button
                    sx={{ textTransform: "none" }}
                    className={`${
                      listRelationshipMappingAccount?.find((e) => e.id === buttonFriendId)?.className
                    } sm:w-[165px] md:w-[204px] h-[44px] text-[13px] flex justify-center rounded-[100px] px-2 items-center gap-1 py-1`}
                    onClick={(event) => {
                      if (buttonFriendId === "friend.relationship.add") {
                        handleInviteFriend(store, infoAccount?.pub_id);
                      } else {
                        handleOpenMenu(event);
                      }
                    }}
                  >
                    {listRelationshipMappingAccount?.find((e) => e.id === buttonFriendId)?.icon}
                    <span
                      className={listRelationshipMappingAccount?.find((e) => e.id === buttonFriendId)?.classNameText}
                    >
                      <FormattedMessage id={buttonFriendId} />
                    </span>
                  </Button>
                  <MenuActionFriend
                    anchorEl={anchorEl}
                    invitationId={infoAccount?.relationship?.invitation_id}
                    memberHid={infoAccount?.pub_id}
                    displayName={infoAccount?.display_name}
                    handleCloseMenu={handleCloseMenu}
                    relationship={buttonFriendId}
                    handleAcceptFriend={handleAcceptFriend}
                    handleDeclineFriendRequest={handleDeclineFriendRequest}
                    handleDeleteInvitation={handleDeleteInvitation}
                    handleDeleteFollow={() => {}}
                    handleRemoveFriend={handleRemoveFriend}
                  />
                  <div>
                    <Button
                      sx={{
                        textTransform: "none",
                        border: "1px solid transparent"
                      }}
                      className={`${
                        listRelationshipMappingAccount?.find((e) => e.id === buttonFollowId)?.className
                      } sm:w-[165px] md:w-[204px] h-[44px] text-[13px] flex justify-center rounded-[100px] items-center gap-1 py-1 px-2`}
                      onClick={() => {
                        if (buttonFollowId === "friend.relationship.following") {
                          handleDeleteFollow(store, infoAccount?.pub_id);
                        } else {
                          handleFollowFriend(store, infoAccount?.pub_id);
                        }
                      }}
                    >
                      {listRelationshipMappingAccount?.find((e) => e.id === buttonFollowId)?.icon}
                      <span
                        className={listRelationshipMappingAccount?.find((e) => e.id === buttonFollowId)?.classNameText}
                      >
                        <FormattedMessage id={buttonFollowId} />
                      </span>
                    </Button>
                  </div>
                </div>
              )}
              {infoAccount?.introduce && (
                <div className={`text-[15px] font-[400] ${checkViewMySelf ? "pt-10 px-4 mb-[-28px]" : "px-4 pt-4"}`}>
                  {infoAccount?.introduce}
                </div>
              )}
            </div>
          ) : (
            <div className="flex md:justify-end flex-row w-full sm:justify-start">
              <div className="tablet:w-[calc(100%-168px-16px)] sm:w-full md:px-5 sm:px-2 flex items-center text-[12px] sm:justify-start sm2:gap-[25px] sm:gap-[10px] md:gap-0 md:justify-between">
                <span className="text-blackQuiz min-w-[65.33px] flex justify-center items-center bg-gray h-[24px] rounded-[12px]">
                  <FormattedMessage id="account.level" values={{ level: infoAccount?.level }} />
                </span>
                <span className="text-blackQuiz py-[5px] sm:w-[50px] md:min-w-[65.33px] h-[24px] bg-gray rounded-[12px] flex items-center gap-[5.33px] justify-center">
                  <span className="mb-[2px]">
                    <Star />
                  </span>
                  <span className="text-[12px] mt-[1px]">{infoAccount?.star}</span>
                </span>
                <button
                  type="button"
                  className={`${
                    infoAccount?.diamond && infoAccount?.diamond > 0 ? "w-[170px]" : "w-[70px]"
                  }  px-[5.66px] h-[24px] bg-gray sm:gap-[4px] rounded-[12px]  flex items-center justify-center md:gap-x-[5.33px]`}
                  onClick={() => router.push("/kim-cuong/nap-kim-cuong")}
                >
                  <IconDiamond fill={theme.palette.primary.main} />
                  <span className="text-blackQuiz">{abbreviateNumberFormatter(infoAccount?.diamond)}</span>
                  {!!infoAccount?.diamond && infoAccount?.diamond > 0 && (
                    <span className="text-gray1 text-[10px]">
                      (HSD:
                      {moment.unix(infoAccount?.diamond_expiry as number).format("DD/MM/YY")})
                    </span>
                  )}
                  <span className="w-5 h-5 flex mt-[1px]">
                    <AddCircleOutlinedIcon />
                  </span>
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AccountPreview;
